import { produce } from 'immer'
import {
  GET_ORGANIZATION_MEMBERS_FAILURE,
  GET_ORGANIZATION_MEMBERS_INIT,
  GET_ORGANIZATION_MEMBERS_SUCCESS,
  GetPeopleMembersActions,
} from 'src/app/PeopleMembers/redux/peopleMembers.actions'
import {
  initialState as initialPeopleMembersState,
  PeopleMembersState,
} from 'src/app/PeopleMembers/redux/peopleMembers.reducer'
import { businessRulesRouteProps } from 'src/navigation/routeProps'
import {
  GetOrganizationsActions,
  PATCH_ORGANIZATIONS_FAILURE,
  PATCH_ORGANIZATIONS_INIT,
  PATCH_ORGANIZATIONS_SUCCESS,
  PatchOrganizationsActions,
} from 'src/redux/actions/data/organizations.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { parseBackendErrors } from 'src/utils/error.utils'

export interface BusinessRulesState {
  isCardApprovalsBeingEdited: boolean
  fetchSuccess: boolean
  fetchFailure: boolean
  patchingOrganizations: boolean
  puttingOrganizations: boolean
  patchOrganizationsTopLevelError?: string
  orgMembers: PeopleMembersState
  topLevelOrganizationApproverError?: string
  patchingOrganizationApprover: boolean
  isOutOfPocketExpensesBeingEdited: boolean
}

export const initialState: BusinessRulesState = {
  isCardApprovalsBeingEdited: false,
  fetchSuccess: false,
  fetchFailure: false,
  patchingOrganizations: false,
  puttingOrganizations: false,
  orgMembers: initialPeopleMembersState,
  patchingOrganizationApprover: false,
  isOutOfPocketExpensesBeingEdited: false,
}

export type Actions =
  | GetOrganizationsActions
  | PatchOrganizationsActions
  | GetPeopleMembersActions

const CoreBusinessRulesReducer = (
  state = initialState,
  action: Actions,
): BusinessRulesState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case PATCH_ORGANIZATIONS_INIT: {
        draft.patchingOrganizations = true
        draft.patchOrganizationsTopLevelError = undefined
        return draft
      }

      case PATCH_ORGANIZATIONS_FAILURE: {
        const { topLevelError } = parseBackendErrors(action.payload)

        draft.patchingOrganizations = false
        draft.patchOrganizationsTopLevelError = topLevelError
        return draft
      }

      case PATCH_ORGANIZATIONS_SUCCESS: {
        draft.patchingOrganizations = false
        draft.patchOrganizationsTopLevelError = undefined
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_INIT: {
        draft.orgMembers.loading = true
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_SUCCESS: {
        draft.orgMembers.loading = false
        return draft
      }

      case GET_ORGANIZATION_MEMBERS_FAILURE: {
        draft.orgMembers.loading = false
        return draft
      }
    }
  })
}

const BusinessRulesReducer = createBackgroundReducer(
  businessRulesRouteProps,
  initialState,
  CoreBusinessRulesReducer,
)

export default BusinessRulesReducer
